// extracted by mini-css-extract-plugin
export default {"root":"PromotionItem_root__5YQ6G","menuItemImage":"PromotionItem_menuItemImage__IQ6OG"};